import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../layout/theme/utils/colors';

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'capitalize',
  minWidth: 125,
  fontSize: 18,
  lineHeight: '23px',
  fontWeight: 400,
  color: Colors.font_gray,
  display: 'flex',
  alignItems: 'center',
  letterSpacing: 0.25,
  padding: 0,
  margin: theme.spacing(0, 1.5),

  '&.Mui-selected': {
    color: Colors.black,
    fontWeight: 600,
  },

  '&:hover': {
    color: Colors.black,
    opacity: 1,
  },
}));

export default StyledTab;
